import { useEffect, useState } from 'react';

export function RateLimitBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    function handleRateLimit() {
      setVisible(true);
      clearTimeout(timer);
      timer = setTimeout(() => setVisible(false), 8000);
    }

    window.addEventListener('api:rate-limit', handleRateLimit);
    return () => {
      window.removeEventListener('api:rate-limit', handleRateLimit);
      clearTimeout(timer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[9999] flex items-center justify-between bg-red-600 px-4 py-3 text-white shadow-lg">
      <p className="flex-1 text-center text-sm font-semibold">
        Troppe richieste al server. Attendi qualche secondo e riprova.
      </p>
      <button
        onClick={() => setVisible(false)}
        className="ml-4 shrink-0 rounded p-1 text-white/80 transition-colors hover:text-white"
        aria-label="Chiudi"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
